export const OAuthSettings = {
  appId: '9bf26259-22b5-4137-b900-56c27dcd0df4',
  scopes: [
    "user.read",
    "user.read.all",
    "calendars.read"
  ]
};
